import type React from 'react';

import { useEmailConfirmation } from '@/hooks/registration/useEmailConfirmation';

import EmailConfirmationView from './EmailConfirmation.view';

export function EmailConfirmation(): React.JSX.Element {
  const { state, handlers } = useEmailConfirmation();

  return (
    <EmailConfirmationView
      codeLength={state.codeLength}
      maskedEmail={state.maskedEmail}
      code={state.code}
      codeError={state.codeError}
      globalError={state.globalError}
      isSubmitting={state.isSubmitting}
      isVerifyDisabled={state.isVerifyDisabled}
      resendDisabled={state.resendDisabled}
      onCodeChange={handlers.handleCodeChange}
      onSubmit={handlers.handleSubmit}
      onResend={handlers.handleResend}
    />
  );
}

EmailConfirmation.displayName = 'EmailConfirmation';

export default EmailConfirmation;
